<template>
  <div class="page">
    <SubHeader :page="page"></SubHeader>

    <div class="security-content">
      At MikMak, we take every possible measure to secure our applications and data. Read below to learn more about how we approach Security within the MikMak Platform.
    </div>


    <div class="security-block" v-for="securityItem in securityContent">

      <h3>{{ securityItem.title }}</h3>

      <div class="security-list-item" v-for="listItem in securityItem.items">
        <span class="security-list-item-span security-list-item-title">{{ listItem.title }}</span>
        <span class="security-list-item-span security-list-item-text">
          <label v-for="textItem in listItem.text" v-html="textItem"></label>
        </span>
      </div>

    </div>

    <div class="security-content">

      Contact <b>security@mikmak.tv</b> with any inquiries not addressed in the content above.

    </div>

  </div>
</template>

<script>

const pageName = 'Security at MikMak'
import SubHeader from './common/SubHeader'

export default {
  mounted() {
    window.scrollTo(0, 0)
  },
  components: {
    SubHeader
  },
  methods: {},
  computed: {
    page() {
      return pageName
    },
    securityContent() {
      return this.$store.state.security
    }
  },
  watch: {}
}
</script>

<style scoped>

  .security-content {
    display: block;
    margin: 32px auto;
    font-family: "Work Sans", sans-serif;
    font-size: 14px;
    text-align: center;
    width: 90%;
    max-width: 600px;
  }

  .security-block {
    font-family: "Work Sans", sans-serif;
    display: block;
    width: 90%;
    max-width: 800px;
    margin: 48px auto;
    padding: 12px;
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.09);
    background: white;
  }

  .security-block h3 {
    font-size: 24px;
    padding: 0px;
    font-weight: normal;
    margin: 12px 0;
  }

  .security-list-item {
    margin-top: 24px;
    border-top: 1px solid #e0e0e0;
    padding-top: 24px;
  }

  .security-list-item-span {
    display: inline-block;
    vertical-align: top;
    font-size: 16px;
  }

  .security-list-item-title {
    width: 30%;
  }

  .security-list-item-text {
    width: 60%;
  }

  .security-list-item-text label {
    display: block;
    margin-bottom: 4px;
  }

  @media only screen and (max-width: 800px) {
    .security-block {
      border: none;
      box-shadow: none;
    }

    .security-list-item-span {
      display: block;
    }

    .security-list-item-title {
      width: 100%;
      font-size: 18px;
      margin-bottom: 12px;
    }

    .security-list-item-text {
      width: 100%;
    }
  }

</style>



// WEBPACK FOOTER //
// Security.vue?12054f20